import { infiniteQueryOptions } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { IPaginatedResponse } from 'types/pagination';
import { IActivity } from 'views/DealDashboard/types';

export interface CRMDealActivitiesQueryParams {
    page?: never;
    page_size?: number;
    activity_type?: string;
    sort_order?: string;
}

const getCRMDealActivitiesInfiniteQueryOptions = (
    organizationId: string,
    dealId: number,
    params: CRMDealActivitiesQueryParams = {},
) => infiniteQueryOptions({
    initialPageParam: 1,
    queryKey: ['CRMInfiniteDealActivities', organizationId, dealId, params],
    queryFn: async ({ pageParam }) => {
        const response = await axiosInstance.get<IPaginatedResponse<IActivity>>(
            API_ENDPOINTS.CRM.DEAL_ACTIVITIES(organizationId, dealId), {
                params: {
                    page: pageParam,
                    ...params,
                },
            },
        );
        return response.data;
    },
    getNextPageParam: (lastPage, _allPages, lastPageParam) => (lastPage.next ? lastPageParam + 1 : null),
});
export default getCRMDealActivitiesInfiniteQueryOptions;
